function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { FormMessage, Icon, P, FlexRow } from "../";
export const MessageBanner = ({
  content,
  onClose,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(FormMessage, _extends({
    InternalField: Container,
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CloseIcon, {
      onClick: onClose,
      platform: true,
      name: "Close"
    }), /*#__PURE__*/React.createElement(Message, null, content))
  }, props));
};
const Message = styled(P).attrs({
  as: "div"
})`
  padding-right: 40px;
`;
const Container = styled(FlexRow)`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: ${props => props.theme.palette[props.color].lightest};
  min-height: 54px;
  padding: 16px 24px;
  width: 100%;
  @media only screen and ${props => props.theme.media.small} {
    padding: 12px 24px;
  }
`;
const CloseIcon = styled(Icon)`
  cursor: pointer;
  position: absolute;
  right: 32px;
  @media only screen and ${props => props.theme.media.small} {
    width: 14px;
    height: 14px;
    top: 18px;
    right: 24px;
  }
`;